// Given a frame size and image size, gets the scale, and x,y, coords
// to match CSS background cover, background-position center
export default function getCoverSize(frameSize, imgSize) {
  const frameRatio = frameSize.width / frameSize.height;
  const sourceRatio = imgSize.width / imgSize.height;
  let scale, transform;
  if (frameRatio > sourceRatio) {
    // frame wider
    scale = frameSize.width / imgSize.width;
    const imgHeight = imgSize.height * scale;
    const imgY = -(imgHeight - frameSize.height) / 2;
    transform = { x: 0 + frameSize.x, y: imgY + frameSize.y };
  } else {
    // image wider
    scale = frameSize.height / imgSize.height;
    const imgWidth = imgSize.width * scale;
    const imgX = -(imgWidth - frameSize.width) / 2;
    transform = { x: imgX + frameSize.x, y: 0 + frameSize.y };
  }
  return { scale, transform };
}



// WEBPACK FOOTER //
// ./src/components/pixi/utils/getCoverSize.js